import React, { useContext } from "react";
import Card from "../components/UI/Card";
import AuthContext from "../store/auth-context";
import classes from "./NotFound.module.css";

const NotFound = () => {
  const AuthCtx = useContext(AuthContext);

  return (
    <Card>
      <h1 className={classes.notfound} onClick={AuthCtx.onLogout}>
        Not Found
      </h1>
    </Card>
  );
};

export default NotFound;